import gql from 'graphql-tag';
import { smallOverlay } from '../fragments/overlay';
import { fullMatchFragment } from '../fragments/match';
import { matchPlayerFragment } from '../fragments/matchPlayer';
import { teamFragment } from '../fragments/team';
import { competitionFragment } from '../fragments/competition';
export const fetchOverlayQuery = gql `
  query overlay($key: String) {
    overlay(key: $key) {
      ...SmallOverlay
    }
  }
  ${smallOverlay}
`;
export const fetchFullOverlayDataQuery = gql `
  query fullOverlayAndMatch($key: String) {
    overlay(key: $key) {
      id
      matchId
      encodingDelay
      autoMode
      resolution
      showWatermarks
      enableAds
      background
      backgroundColor
      manualGraphicState
      matchId
      key
      match {
        ...FullMatch
      }
    }
  }
  ${fullMatchFragment}
  ${competitionFragment}
  ${matchPlayerFragment}
  ${teamFragment}
`;
//# sourceMappingURL=overlay.js.map